import { render, staticRenderFns } from "./equipmentHistory_page.vue?vue&type=template&id=fd64e65a&scoped=true"
import script from "./equipmentHistory_page.vue?vue&type=script&lang=js"
export * from "./equipmentHistory_page.vue?vue&type=script&lang=js"
import style0 from "./equipmentHistory_page.vue?vue&type=style&index=0&id=fd64e65a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd64e65a",
  null
  
)

export default component.exports